import './index.scss'

const Projects = () => {
    return(    
        <div className='projects container'>
        <div className='text'>
            <head>
            Projects
            </head>
            <figure>
                <figcaption>&nbsp;Inter-Planetary File System Block Chain</figcaption>
                <ul>
                    <li>As part of my senior project for Hunter College, I along with three other group members designed an
                        Inter-Planetary File System, which is a peer to peer file sharing system that uses block chain technology to
                        keep track of revisions to files on the network to ensure security and the integrity of the files. I designed the
                        block chain data structure in particular from scratch using Python.</li>
                </ul>
                <figcaption>&nbsp;Metro Muse</figcaption>
                <ul>
                    <li>A desktop app written in Python using libraries such as Pandas, Folium and PyQt that visualizes foot traffic
                        data given by users in order to inform avid music fans where they can find local music playing, as well as
                        musicians themselves to see where they can perform and maximize audience members.</li>
                </ul>
                <figcaption>&nbsp;Blend</figcaption>
                <ul>
                    <li>An iOS app written in Swift and Objective C designed for connect college students seeking to get into the
                        dating scene. Working with 4 other people, each week for a month we discussed features we wanted to
                        implement and designated tasks. I helped implement the frontend (controllers, bounding boxes, etc) and
                        backend (API calls for user login and feed, button functionality) elements of the home screen of the app.</li>
                </ul>
            </figure>
        </div>
        </div>
    )
}

export default Projects